import React, { useState } from "react";
import { Link } from "react-router";
// const [isActive, setIsActive] = useState(false);
import logo from './../../../../assets/images/users/fulllogo_nobuffer.png'

  

export default function Navbar() {
  const [isActive, setIsActive] = useState(false);
const toggleMenu = () => {
    setIsActive(!isActive);
  };
  return (
    <nav className="navbar">
      <div>
         <Link to="/">
        <img className="logoimg" src={logo} alt="Logo"/>
     </Link>
    </div>



      <div className={`nav-menu ${isActive ? "active" : ""}`}>
        <ul>
          <li><Link to="/">Home</Link></li>
          {/* <li><Link to="/about-us">About Us</Link></li> */}
          {/* <li><a href="services.html">Services</a></li> */}
          <li><Link to="/about-us">About Us</Link></li>

          <li><Link to="/blogs">Blogs</Link></li>
          {/* <li><Link to="/rent/bike">Rent</Link></li>
          <li><Link to="/how-motourax-works">How it works</Link></li> */}

          {/* <li><a href="how-it-works.html" className="active">How It Works</a></li> */}
        </ul>
    </div>

      <div className="icons">
        {/* <a href="#" className="login-btn">Login/Sign Up</a> */}
        {/* <i className="fas fa-search"></i>
        <i className="fas fa-shopping-cart"></i> */}
        <div className={`hamburger ${isActive ? "active" : ""}`}
          onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
    
  );
}